import { combineReducers } from "redux";
import assessmentReducer from "./assessmentReducer";
import unBounceModalReducer from "./unBounceModalReducer";
import sessionReducer from "./sessionReducer";
import notificationReducer from "./notificationReducer";

export default combineReducers({
  freeAssessment: assessmentReducer,
  unBounceModal: unBounceModalReducer,
  session: sessionReducer,
  notification: notificationReducer,
});
